{
  "library": {
    "addToJingles": "Add to jingles",
    "addToPlaylist": "Add to playlist",
    "badge1080p": "1080p",
    "badge4K": "4K",
    "badgeProcessing": "Processing…",
    "badgeProcessingTooltip": "We're reading this file's details so it's ready to stream. This usually takes under a minute — you can keep using the dashboard.",
    "badgeUnsupported": "Unsupported",
    "bulkAddSkipped": "{{count}} file(s) skipped: still processing, unsupported, or above this stream's resolution.",
    "encodeCancelled": "Encode cancelled",
    "encodeFailed": "Encode failed",
    "encodeQueued": "Queued for encoding",
    "encodeRunning": "Encoding {{percent}}%",
    "probePendingTooltip": "Video is still being processed — try again in a moment.",
    "tierMismatchTooltip": "This video's resolution doesn't match the stream's resolution.",
    "tierTooHighTooltip": "This is a {{itemTier}} video, but this stream is {{streamTier}}. Use a {{streamTier}} version, or move it to a {{itemTier}} stream.",
    "unsupportedTooltip": "This video's resolution isn't supported. Only 1080p and 4K are allowed.",
    "unsupportedBasicTooltip": "This video's resolution isn't supported for this stream.",
    "badgeUnreadable": "Can't read file",
    "unreadableTooltip": "We couldn't read this file. It may be damaged or in a format we can't open. Delete it and upload it again, or export it as MP4 first.",
    "thumbnailFailedTooltip": "Thumbnail failed. Open Edit to choose another time or retry.",
    "encodeRetry": "Retry",
    "encodeRetryStarted": "Encoding restarted.",
    "encodeRetryChecking": "We're checking the previous encode first. Press Retry again in a minute if it doesn't restart.",
    "folderFileCount_one": "{{count}} file",
    "folderFileCount_other": "{{count}} files",
    "folderDeleteTooltip": "Delete folder",
    "folderDeleteTitle": "Delete this folder?",
    "folderDeleteBody": "The folder and every file in it are deleted from your library for good. You can't undo this.",
    "folderDeleteCancel": "Cancel",
    "folderDeleteOk": "Delete folder",
    "addToShow": "Add to a show",
    "folderRenameTooltip": "Rename folder",
    "folderOpenTooltip": "Open folder",
    "folderNameLabel": "Folder name"
  },
  "upload": {
    "cancelAll": "Cancel all",
    "inProgress": "{{count}} upload(s) in progress...",
    "minimize": "Minimize",
    "overallProgress": "Overall progress",
    "statusCancelled": "cancelled",
    "statusFailed": "failed",
    "title": "Upload progress",
    "toFolder": "To folder:",
    "summary": "{{done}} of {{total}} complete",
    "minimizedTooltip": "{{done}} of {{total}} uploaded",
    "actions": "Upload actions",
    "expand": "Show uploads",
    "cancel": "Cancel upload",
    "rowStatus": {
      "pending": "Waiting",
      "uploading": "Uploading",
      "completed": "Completed",
      "failed": "Failed",
      "cancelled": "Cancelled",
      "releasePending": "Cancelled — quota release pending"
    }
  },
  "row": {
    "authorTooltip": "Author: {{name}}",
    "unknownAuthor": "Unknown",
    "editTooltip": "Edit title and author",
    "moreActions": "More actions",
    "download": "Download",
    "duplicate": "Duplicate",
    "duplicateTitle": "Duplicate this file?",
    "duplicateBody": "A copy is added to your library.",
    "deleteTitle": "Delete this file?",
    "deleteBody": "It's deleted from your library for good. You can't undo this.",
    "editTitleLabel": "Title",
    "editAuthorLabel": "Author",
    "removeFromPlaylist": "Remove from playlist",
    "moveToFolder": "Move to folder",
    "bulkDeleteTitle": "Delete the selected files?",
    "bulkDeleteBody": "The selected files ({{count}}) are deleted from your library for good. You can't undo this."
  }
}
